/** URL(SAS 토큰 포함)로 브라우저 다운로드를 트리거한다. */
export const triggerBrowserDownload = (url: string, fileName?: string) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  if (fileName) anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
